import { Signal } from '@angular/core';
import { HttpParams } from '@angular/common/http';

export const DEFAULT_PAGE_SIZE = 25;
export const PAGE_SIZE_OPTIONS = [25, 50, 100, 250];
export const SEARCH_DEBOUNCE_TIME = 300;

type PaginationSignals = {
  search: Signal<string>;
  pageIndex: Signal<number>;
  pageSize: Signal<number>;
};

// Query-Parameter für den nestjs-paginator der API
export function toPaginationParams(
  state: PaginationSignals,
  params: HttpParams,
): HttpParams {
  params = params
    .set('page', state.pageIndex() + 1)
    .set('limit', state.pageSize());

  const search = state.search()?.trim();

  return search ? params.set('search', search) : params;
}
